export const FontsFromInsert = {
  flow: 'y',
  gap: 'Z',
  CaptionTitle: {
    Text: {
      text: 'Fonts',
    },
  },
};